import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../services/api';

const AdminDashboard = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            await logout(token);
        }
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-gray-100">
            <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center">
                        <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
                        <button
                            onClick={handleLogout}
                            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                        >
                            Logout
                        </button>
                    </div>
                    
                    <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        <Link
                            to="/admin/add-product"
                            className="block p-6 bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-50"
                        >
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">Add New Product</h5>
                            <p className="font-normal text-gray-700">
                                Create and add new products to the store
                            </p>
                        </Link>
                        <Link
                            to="/admin/products"
                            className="block p-6 bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-50"
                        >
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">Manage Products</h5>
                            <p className="font-normal text-gray-700">
                                View, edit, and delete products
                            </p>
                        </Link>
                        <Link
                            to="/admin/upload-excel"
                            className="block p-6 bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-50"
                        >
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">Upload Excel</h5>
                            <p className="font-normal text-gray-700">
                                Bulk upload products from Excel file
                            </p>
                        </Link>
                        <Link
                            to="/admin/settings"
                            className="block p-6 bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-50"
                        >
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">Settings</h5>
                            <p className="font-normal text-gray-700">
                                Configure homepage and other settings
                            </p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
